import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer id="footer">
            <section>
                <h2>Personal Training ?</h2>
                <p>We provide personal training as well. Contact for more details</p>
            </section>
            <section>
                <h2>Muscle Creator</h2>
                <dl class="alt">
                    <dt>Address</dt>
                    <dd>Kothari Watika no 4 Malkapur, Akola &bull; Akola, MH 444001 &bull; India</dd>
                    <dt>Phone</dt>
                    <dd>(000) 000-0000 x 0000</dd>
                    <dt>Email</dt>
                    <dd><a href="#">suyogtarole@gmail.com</a></dd>
                </dl>
                <ul class="icons">
                    <li><a href="#" class="icon brands fa-instagram alt"><span class="label">Instagram</span></a></li>
                </ul>
            </section>
        </footer>
    );
}

export default Footer;